import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../../assets/css/booking.module.css';
import TarcoLogo from '../../assets/img/tarcoaviation-logo.png';
import LoadingSpinner from '../../common/LoadingSpinner';
import { SEATS } from '../../constants/index';

const Seats = (props) => {
  const { booking, status, back, finalize, error } = props;

  const [selectedSeat, setSelectedSeat] = useState({ letter: null, row: null });
  const rowsCount = SEATS.length - 1;

  const handleSeatSelection = (seatRow, seat) => {
    if (seat.available) setSelectedSeat({
      letter: seat.letter,
      row: seatRow.number
    });
  };
  return (
    <>
      <div className={classNames(styles.container, styles.seats_flight_info)}>
        <div className={styles.offer_main_information}>
          <img src={TarcoLogo} alt='Tarco Airlines' width={'40px'} style={{ borderRadius: '25px' }} />
          <div className={styles.information_block}>
            <div>
              <p>{booking?.origin?.iataCode}</p>
              <p>{booking?.origin?.nameAr}</p>
            </div>
          </div>
          <span className="iconify card_arrow reverse" data-icon="fluent:airplane-24-filled"></span>
          <div className={styles.information_block}>
            <div>
              <p>{booking?.destination?.iataCode}</p>
              <p>{booking?.destination?.nameAr}</p>
            </div>
          </div>
        </div>
      </div>

      <div className={classNames(styles.container, styles.seats_map_container)}>
        <p>اختر مقعدك من الخريطة</p>
        <div className={styles.seats_map_guide}>
          <div>
            <div className={styles.available_seat}></div>
            <p>متوفر</p>
            <p>($30 - $50)</p>
          </div>
          <div>
            <div className={styles.unavailable_seat}></div>
            <p>غير متوفر</p>
          </div>
          <div>
            <div className={styles.seat_with_conditions}>*</div>
            <p>مقعد له شروط خاصة</p>
          </div>
        </div>
        <div className={styles.seats_map_main_spacer}>
          <p> مقاعد الدرجة الإقتصادية - الصفوف {SEATS[0].number} الى {SEATS[rowsCount].number}</p>
        </div>
        {
          SEATS.map(seatsRow => {
            return (
              <div className={styles.seats_map_row_names}>
                {
                  seatsRow.columns.map((column, index, columnsCount) => {
                    return (
                      <>
                        <div className={styles.seats_row}>
                          {column.seats.map(seat => {
                            const isSelected = seat.letter === selectedSeat.letter && seatsRow.number === selectedSeat.row;
                            return (
                              <div className={styles.seats_column} onClick={() => handleSeatSelection(seatsRow, seat)}>
                                <p>{seat.letter}</p>
                                <div className={classNames(styles.seat, 'tooltip')}>
                                  <div className={classNames(seat.available ? styles.available_seat : styles.unavailable_seat, isSelected && styles.selected_seat)}></div>
                                  <span className="bottom-tooltip-text">{seat.available ? `${seatsRow.number}${seat.letter} - متاح` : `${seatsRow.number}${seat.letter} - غير متاح`}</span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        {index !== columnsCount.length - 1 &&
                          <div className={styles.seats_map_spacer}>
                            {seatsRow.number}
                          </div>
                        }
                      </>
                    );
                  })
                }
              </div>
            );
          })
        }
      </div>
      <div className={styles.steps_indicator_buttons}>
        <button className='button simple_button' onClick={back}>
          <span className="iconify" data-icon="ic:round-chevron-right"></span>
          الخلف
        </button>
        {/* <button className='button' onClick={finalize}>
          التالي
          <FaChevronLeft />
        </button> */}
        <button className="button" onClick={finalize} disabled={status === 'submitting'}>
          التالي
          {status === 'submitting' ?
            <LoadingSpinner /> :
            <div>
              <span className="iconify" data-icon="ic:round-chevron-left"></span>
            </div>
          }
        </button>
      </div>
      {
        error &&
        <div className="error no-margin-top">
          <span className="iconify" data-icon="zondicons:exclamation-solid"></span>
          <p>نأسف, حدث خطأ غير متوقع, حاول مرة أخرى بعد قليل</p>
        </div>
      }
    </>
  );
};

export default Seats;